import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=c80edaaa&scoped=true&"
import script from "./top-header.vue?vue&type=script&lang=js&"
export * from "./top-header.vue?vue&type=script&lang=js&"
import style0 from "./top-header.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./top-header.vue?vue&type=style&index=1&id=c80edaaa&lang=scss&scoped=true&"
import style2 from "./top-header.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80edaaa",
  null
  
)

export default component.exports